import * as React from 'react';
import Button from '@mui/joy/Button';
import { Card, Divider, Grid, Typography, Box } from "@mui/joy";
import { CardActions } from '@mui/material';
import Sheet from '@mui/joy/Sheet';
import Reviews from './Reviews';
import { useThemeContext } from '../context/ThemeContext';

import BiddersCard, { CraftsCard } from '../blocks/customer/cardsection/BiddersCard';



const profiledata = [
    {
        id: "6541654651",
        reviews: "Customer Reviews",
        job: "Post Job",
        servicecategories: "Plumbing",
        subcategories: "Pipe Instalation",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit",
        role: "customer",
        Date: "50/11/2025",
        imagesUrl: "Mask group (1)",
        star: 4,
        name: "Roby Rock",
        location: "Lucknow"
    },
    {
        id: "6541654651",
        reviews: "Customer Reviews",
        job: "Post Job",
        servicecategories: "Plumbing",
        subcategories: "Pipe Instalation",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit",
        role: "customer",
        Date: "50/11/2025",
        imagesUrl: "Mask group (1)",
        star: 4,
        name: "Roby Rock",
        location: "Lucknow"
    },
    {
        id: "6541654651",
        reviews: "Customer Reviews",
        job: "Post Job",
        servicecategories: "Plumbing",
        subcategories: "Pipe Instalation",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit",
        role: "customer",
        Date: "50/11/2025",
        imagesUrl: "Mask group (1)",
        star: 4,
        name: "Roby Rock",
        location: "Lucknow"
    },
    {
        id: "6541654651",
        reviews: "Customer Reviews",
        job: "Post Job",
        servicecategories: "Plumbing",
        subcategories: "Pipe Instalation",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit",
        role: "customer",
        Date: "50/11/2025",
        imagesUrl: "Mask group (1)",
        star: 4,
        name: "Rocky",
        location: "Lucknow"
    },

]


export default function Profile() {

    const { isSM, isMd, isMD, isLg } = useThemeContext()

    return (
        <>

            <Box
                sx={{
                    width: isSM ? '100%' : isMD ? '100%' : isMd ? '1007px' : isLg ? '1207px' : '1207px',
                    padding: isSM ? '5px' : isMD ? '10px' : isMd ? '10px' : 0,
                    margin: '0 auto',
                    boxSizing: 'border-box',
                }}
            >

                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                    <Box sx={{ marginLeft: isSM ? '0.5rem' : isMD ? '2rem' : isMd ? '3rem' : isLg ? '4rem' : '4rem', }}>
                        <BiddersCard/>
                    </Box>
                    <Card
                        sx={{
                            textAlign: 'center',
                            alignItems: 'center',

                            width: isSM ? '150px' : isMD ? '100%' : isMd ? '343px' : isLg ? '343px' : '343px',
                            padding: isSM ? '5px' : isMD ? '10px' : isMd ? '1rem' : 0,
                            
                            border: 'none',
                            boxShadow: 'none',
                            backgroundColor: '#F4F4F4',
                            borderRadius: '12px'
                        }}
                    >

                        <Typography level="title-lg" sx={{ fontSize: "2rem" }}>
                            €  120
                        </Typography>

                        <CardActions
                            sx={{
                                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                                height: '100px',
                                width: isSM ? '150px' : isMD ? '160px' : isMd ? '180px' : isLg ? '240px' : '240px',


                            }}
                        >


                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',


                                }}
                            >
                                <Button variant="outlined"
                                    sx={{

                                        backgroundColor: "#fff",
                                        width: isSM ? '140px' : isMD ? '150px' : isMd ? '200px' : isLg ? '210px' : '210px',
                                        height: "36px",
                                        
                                        padding: isSM ? '5px' : isMD ? '10px' : isMd ? '1rem' : 0,


                                        marginBottom: '20px',
                                        color: "#28A745",
                                        border: "0.5px solid #28A745",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        borderRadius: "6px",
                                        lineHeight: "19.5px",
                                        "&:hover": {
                                            backgroundColor: "#ffe",
                                            color: "#28A745", boxShadow: 3,
                                        }
                                    }}
                                >
                                    Chat
                                </Button>
                                <Button variant="contained"
                                    sx={{
                                        backgroundColor: "#28A745",
                                        width: isSM ? '140px' : isMD ? '150px' : isMd ? '200px' : isLg ? '210px' : '210px',
                                        height: "36px",
                                        padding: isSM ? '5px' : isMD ? '10px' : isMd ? '1rem' : 0,
                                        borderRadius: "6px",
                                        color: "#fff",
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        lineHeight: "19.5px"
                                    }}

                                >
                                    Follow
                                </Button>
                            </Box>
                        </CardActions>
                    </Card>

                </Box>

                <div className="row">

                    <Typography level="h2" sx={{ color: "#666666", fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '24px' : '24px' }}>
                        About Me
                    </Typography>

                    <Typography level="body-xs" sx={{ fontWeight: 400, width: "100%", fontSize: isSM ? '14px' : isMD ? '16px' : isMd ? '18px' : '18px', marginTop: "10px", marginBottom: "10px" }}>
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequatur doloribus illo rerum ab cum voluptate, esse delectus! Totam, quod non. Non earum qui minima voluptatum eius officia consectetur, a aliquam quos at mollitia esse vitae natus recusandae, laudantium temporibus ullam! Adipisci qui in repudiandae, sed necessitatibus quibusdam magni blanditiis cupiditate tempore sit. Amet repellat illo voluptate atque odio est exercitationem quibusdam debitis necessitatibus quisquam porro sequi voluptas possimus iusto fugit laudantium, quae repellendus vel, harum at molestias qui. Itaque labore ipsam fuga? Doloremque, neque. Inventore error omnis saepe tempore asperiores tempora ea, architecto sit rem! Animi atque dicta aperiam quaerat consectetur earum et odit enim unde. Amet labore blanditiis voluptatibus accusamus aut eaque asperiores iusto nisi, in, deserunt nihil, rem dignissimos harum cumque! Aliquid, repellat sint deleniti at quo inventore repellendus! Recusandae doloremque, cupiditate laudantium alias dolores quam fuga possimus, assumenda suscipit rem distinctio voluptas ea aut! Cum, sit aperiam?
                    </Typography>
                </div>
                <div className="row">
                    <Typography level="h2" sx={{ color: "#666666", fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '24px' : '24px' }}>
                        Skill
                    </Typography>

                    <Typography level="body-xs" sx={{ fontWeight: 400, width: "100%", fontSize: isSM ? '14px' : isMD ? '16px' : isMd ? '18px' : '18px', marginTop: "10px", marginBottom: "10px" }}>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem, possimus distinctio? Laudantium exercitationem quo quia!

                    </Typography>
                </div>
                <Typography level="h2" sx={{ color: "#666666", fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '24px' : '24px' }}>
                    Recent Jobs
                </Typography>
                <Grid
                    container
                    spacing={{ xs: 0, md: 0 }}
                    columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                    sx={{ flexGrow: 1, width: '100%' }}
                >

                    {Array.from(profiledata).map((data, index) => (
                        <Grid key={index} xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "2rem", marginBottom: "3rem" }}>
                            <Card
                                size="lg"
                                variant="solid"
                                sx={{
                                    width: '100%',
                                    display: 'grid',

                                    borderRadius: "20px",
                                    border: "1px solid #666666",
                                    backgroundColor: "#fff"
                                }}
                            >



                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 0,
                                    width: '100%',
                                    margin: 'auto',

                                }}
                                >
                                    <Box>
                                        <Typography level="h3" sx={{ fontWeight: 'lg', }}>{data.id}</Typography>
                                    </Box>
                                    <Button variant="outlined"
                                        sx={{
                                            height: isSM ? '30px' : isMD ? '32px' : isMd ? '36px' : isLg ? '36px' : '36px',
                                        
                                            backgroundColor: "#f0e9bd",
                                            
                                            color: "#CEBC35",
                                            padding: "10px 50px",
                                            border: "1px solid #f0e9bd",

                                            "&:hover": {
                                                backgroundColor: "#f0e9bd",
                                                color: "#CEBC35", boxShadow: 3
                                            },
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        {data.job}
                                    </Button>
                                </Box>

                                <Divider
                                    inset="none"
                                    sx={{
                                        width: "100%",
                                        height: "3px",

                                        borderColor: "#000000",
                                        backgroundColor: "#000000",

                                    }}
                                />

                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: "#fff",
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>service categories</Typography>
                                    </div>

                                    <div>
                                        <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                                            {data.servicecategories}
                                        </Typography>

                                    </div>
                                </Sheet>



                                <Sheet
                                    sx={{


                                        display: 'flex',
                                        backgroundColor: "#fff",
                                        gap: 2,
                                        '& > div': { flex: 1 },
                                    }}
                                >
                                    <div>

                                        <Typography sx={{ fontWeight: 'lg' }}>subcategories</Typography>
                                    </div>

                                    <div>
                                        <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                                            {data.subcategories}
                                        </Typography>

                                    </div>
                                </Sheet>
                                <Divider
                                    inset="none"
                                    sx={{
                                        width: "100%",
                                        height: "2px",
                                        borderWidth: 2,
                                        borderColor: "#000000",
                                        backgroundColor: "#000000"

                                    }}
                                />


                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',

                                    width: '100%',

                                    margin: 'auto',

                                }}
                                >
                                    <Box>
                                        <Typography variant="h3" sx={{ fontWeight:600, fontSize: isSM ? '14px' : isMD ? '16px' : isMd ? '18px' : '18px', }}>{data.reviews}</Typography>
                                    </Box>

                                </Box>


                                <Box display="flex" justifyContent="space-around" alignItems="center" gap={2}>
                                        <CraftsCard/>
                                        <Box sx={{ width: '100%'}}>
                                            <Typography variant="h3" sx={{ fontWeight:600,fontSize: isSM ? '12px' : isMD ? '16px' : '18px' }}>
                                                {data.name}
                                            </Typography>
                                            <Typography sx={{ fontWeight: 'bold',fontSize: isSM ? '12px' : isMD ? '16px' :'18px' }}>
                                                {data.role}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Reviews />
                                            
                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    fontWeight: 400,
                                                    width: '100%',
                                                   
                                                    fontSize: isSM ? '12px' : isMD ? '16px' : isMd ? '18px' : '18px',
                                                    mt: 2,
                                                    
                                                    
                                                }}
                                            >
                                                {data.description}
                                            </Typography>
                                        </Box>
                                    </Box>

                           
                            </Card>


                        </Grid>
                    ))}
                </Grid>
            </Box>




        </>
    );
}
